import { Link } from "@menu/core/types";
import MenuContext from "@menu/core/menu.context";
import { connectCache, connectCacheTimeToLiveInSecs } from "../services/legacy/connect.api";
import { gotoUrl } from "../lib";

const jsFuncPrefix = "js-call-func";

const isFunction = (link: Link) => link.link.startsWith(jsFuncPrefix);

const useOpenLink = (context: MenuContext) => {

    const { settings, connectToken } = context;
    const connectStore = connectCache.value;

    const formatPayAtUrl = (link: string) => {
        if (link !== "https://payat.io/dstv/" || connectStore.CustomerNumber) {
            return link;
        }

        const expandLink = "?utm_source=DSTV&utm_medium=Web&utm_campaign=Bills";
        link = link + connectStore.CustomerNumber + expandLink;

        return link;
    }

    const getExternalLink = (link: string) => {
        if (!settings.externalLinks?.length) {
            return link;
        }

        const domains = settings.externalLinks;
        const match = domains.find(x => link.includes(x));

        if (!match) {
            return link;
        }

        const isGetDstv = match.includes("getdstv");// && match.includes("dstv.co.za"));

        const access = connectToken?.access ?? connectStore?.access_token;
        const id = connectToken?.id ?? connectStore?.id_token;

        if (access && id) {
            const tokenBase = !isGetDstv
                ? `#token_type=bearer&expires_in=${connectCacheTimeToLiveInSecs}&access_token=`
                : "?access_token=";
            link = `${link}${tokenBase}${access}&id_token=${id}`;
        } else if (isGetDstv) {
            link = `${link}?access_token={}&id_token={}`
        }

        if (connectStore) {
            link = formatPayAtUrl(link);
        }

        return link;
    }

    const openLink = (e: any, link: Link, context: MenuContext) => {
        e.preventDefault();
        e.stopPropagation();

        if (!isFunction(link)) {
            const url = getExternalLink(link.link);
            gotoUrl(url, link.openInNewWindow);
            return;
        }

        const func = link.link.split("/")[1];

        switch (func) {
            case "sign-out":
                context.authService.signOut();
                break;
        }
    }

    return openLink;
}

export default useOpenLink;
